import { Controller } from "@hotwired/stimulus"
import SlimSelect from 'slim-select'

export default class extends Controller {
    static values = { placeholder: String, url: String }

    connect() {
        console.log(this.urlValue)
        this.slim = new SlimSelect({
            select: this.element,
            settings: {
                placeholderText: this.placeholderValue,
            },
            events: {
                search: (search, currentData) => {
                    return new Promise((resolve, reject) => {
                        if (search.length < 2) {
                            return reject('Search must be at least 2 characters')
                        }

                        this.fetchCollection(this.urlValue, search)
                            .then(resolve)
                            .catch(reject)
                    })
                }
            }
        })
    }

    async fetchCollection(url, searchString) {
        console.log(url)
        if (!url) return []

        const params = new URLSearchParams({ q: searchString })
        const response = await fetch(`${url}?${params}`)

        if (response.ok) {
            return await response.json()
        }
    }

    disconnect() {
        if (this.slim) {
            this.slim.destroy()
        }
    }
}